export default {"src":"/_next/static/media/terraform_on-light.cfb4ea43.svg","height":72,"width":245,"blurWidth":0,"blurHeight":0};